import React from 'react'
import {Flex} from '/app/src/component'
import style from './style.css'
import {List, Map} from 'immutable';
import {history} from '/app/src/store';
import DateTime from '/app/src/lib/DateTime'
import SVG from 'react-inlinesvg';
import {connect} from 'react-redux';
import EmployeeSelector from '/app/src/model/Employee/selector';
import CompanySelector from '/app/src/model/Company/selector';
import ConversationSelector from '/app/src/model/Conversation/selector';

class JibberBanner extends React.Component {

    constructor(props) {
        super(props)
        this._onClick = this._onClick.bind(this)
    }

    _onClick() {
        history.push({pathname: '/'})
    }

    _renderIcon(src, str) {
        return (
            <Flex my='5px' marginRight='19px'>
                <Flex paddingRight='6px'>
                    <SVG cacheGetRequests={true} style={{fill: 'white', width: '18px', height: '18px'}} src={src}/>
                </Flex>
                {str}
            </Flex>
        )
    }

    //Truncates if necessary, looks better.
    __prettyAvgTime(time) {
        const prettyTime = time.split(' ')
        if (prettyTime.length > 2) return prettyTime[0] + ' ' + prettyTime[1]
        return time
    }

    render() {
        const { imgSrc } = this.props
        const prettyAvgTime = this.__prettyAvgTime(this.props.avgResponseTime)
        return <Flex width='100%' className={style.Banner}>
            <Flex width='50%'>
                <Flex vAlignContent='top' cursor='pointer' margin='15px' onClick={this._onClick}>
                    <SVG src={imgSrc} style={{height: '22px', width: '89px'}} alt='jibber logo'/>
                </Flex>
            </Flex>
            <Flex justifyContent vAlignContent='center' width='50%'>
                <Flex column>
                {this._renderIcon('/images/Conversations_SM.svg', this.props.nbrActiveTickets)}
                {this._renderIcon('/images/IncomingErrands_SM.svg', this.props.nbrUnassignedTickets)}
                </Flex>
                <Flex column>
                {this._renderIcon('/images/ResponseTime_SM.svg', prettyAvgTime)}
                {this._renderIcon('/images/Employee_SM.svg', this.props.nbrOnlineEmployee)}
                </Flex>
            </Flex>
        </Flex>
    }
}

function mapStateToProps(state) {
    let liveStats = state.getIn(['company','stats', 'live', 'payload'], Map())
    let plan = CompanySelector.getPaymentPlan(state)
    let imgSrc = ''
    switch(plan) {
        case 'pro':
            imgSrc = '/images/JibberLogo_PRO.svg'
            break
        default:
        case 'start':
            imgSrc = '/images/Start_L.svg'
            break
    }
    let nbrOnlineEmployee = EmployeeSelector.getOnlineCoworkers(state).size
    let nbrUnassignedTickets = ConversationSelector.unassignedTickets(state).size
    let avgResponseTime = liveStats.getIn(['avgs', 0, 'second'], List()).toJS()
    let sum = 0
    for(var t in avgResponseTime) {
        sum += avgResponseTime[t][0]
    }
    avgResponseTime = sum===0?'N/A':DateTime.convertSecondsToHour(Math.floor(sum/avgResponseTime.length));
    let nbrActiveTickets = liveStats.get('nbr_active_tickets')

    return { nbrOnlineEmployee, nbrUnassignedTickets, avgResponseTime, nbrActiveTickets, imgSrc}
}

export default connect(mapStateToProps)(JibberBanner);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/Header/Banner/index.js